import React from "react";
import { post } from '../../utilities/request';
import produce from 'immer';
import * as yup from 'yup';


class FormWizard extends React.Component {

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFormCleanup = this.handleFormCleanup.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCleaveChange = this.handleCleaveChange.bind(this);
    this.handleChoiceListChange = this.handleChoiceListChange.bind(this);
    this.handleReactSelectChange= this.handleReactSelectChange.bind(this);
    this.setFieldValue = this.setFieldValue.bind(this);
    this.findAndReplacePathInError = this.findAndReplacePathInError.bind(this);
    this.setErrorByPath = this.setErrorByPath.bind(this);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    post(this.props.formAction, {...this.state.object, ...{authenticityToken: this.props.authenticityToken}})
      .then(this.handleFormSuccess)
      .catch(this.handleFormFailure)
      .then(this.handleFormCleanup)
  }

  handleChange = (field) => {
    return (value) => this.setFieldValue(field, value)
  }

  handleSelection = (field, value) => {
    return () => this.setFieldValue(field, value)
  }

  handleCleaveChange = (field, useRawValue) => {
    return (event) => this.setFieldValue(field, useRawValue ? event.target.rawValue : event.target.value)
  }

  handleChoiceListChange = (field) => {
    return (value) => this.setFieldValue(field, value[0].toString())
  }

  handleReactSelectChange = (field) => {
    return (option) => {
      this.setFieldValue(field, option.value)
    }
  }

  setFieldValue = (field, event) => {
    let value = null;
    if (typeof event === 'string' || event instanceof String) {
      value = event
    } else {
      event.persist()
      value = event.target.value
    }

    this.setState(
      produce(draft => {
        let arrField = field.split(".")
        let reducer = (accumulator, currentValue, currentIndex) => {
          let isLastKey = ((currentIndex + 1) === arrField.length);
          let currentValueOrIndex = parseInt(currentValue) ? parseInt(currentValue) : currentValue
          return accumulator[currentValueOrIndex] = (isLastKey ? accumulator[currentValueOrIndex] = value : (accumulator[currentValueOrIndex] || {}))
        }
        arrField.reduce(reducer, draft.object);
      })
    )
  }


  validateField = (stepSchema, schemaPath) => {
    return (e) => {
      yup.reach(stepSchema, schemaPath ).validate(e.target.value)
      .then((value) => {
        this.setState(
          produce(draft => {
            delete draft.errors[schemaPath]
          })
        )
      })
      .catch((err) => {
        this.setErrorByPath(schemaPath, err)
      })
    }
  }

  setErrorByPath = (path, err) => {
    this.setState(
      produce(draft => {
        draft.errors[path] = err.errors.map(this.findAndReplacePathInError(path))
      })
    )
  }

  findAndReplacePathInError = (path) => {
    return (error) => {
      if (error.indexOf(path) !== -1) {
        return error.replace(path, objectNameFromPath(path) )
      }
      else if (error.indexOf("this") === 0) {
        return error.replace("this", objectNameFromPath(path))
      } else {
        return error
      }
    }
  }

  handleFormCleanup = () => {
    this.setState({ isLoading: false })
  }
}

export default FormWizard
